
export const selectProps = {
  /*
   *  html element ot append the sele to
   */
  appendTo: {
    type: [String, Object],
    default: 'body'
  },
  /*
   *
   */
  ariaLabel: {
            type: String,
            default: null
        },
        ariaLabelledBy: {
            type: String,
            default: null
        },
  autoFilterFocus: {
    type: Boolean,
    default: false
  },
  autoOptionFocus: {
    type: Boolean,
    default: false,
  },
  checkmark: {
    type: Boolean,
    default: false,
  },
  dataKey: null,
  /*
   *  determines if the input is editable, or we are
   *  limited only to the options listed
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  editable: {
    type: Boolean,
    default: false,
  },
  emptySelectionMessage: {
    type: String,
    default: null
  },
  /*
   *  Provide a filter for the options
   */
  filter: {
    type: Boolean,
    default: false
  },
  /*
   *  Fields of the obptions objects that should be used
   *  by the filter
   */
  filterFields: {
    type: Array,
    default: null
  },
  /*
   *  Filters use diffrent matchign modes, but 'contains' is
   *  by far the most common
   */
  filterMatchMode: {
    type: String,
    default: 'contains',
    validate: (x)=>['gte', 'lte', 'eq', 'contains'].includes(x),
  },

  filterMessage: {
    type: String,
    default: null,
  },

  filterPlaceholder: {
    type: String,
    default: 'Filter...',
  },

  filterEmptyMessage: {
    type: String,
    default: 'No matching options',
  },

  highlightOnSelect: {
    type: Boolean,
    default: true
  },

  inputId: {
    type: String,
    default: null,
  },

  inputClass: {
    type: [String, Object],
    default: null,
  },

  inputStyle: {
    type: [String, Object],
    default: null,
  },

  invalid: {
    type: Boolean,
    default: false,
  },

  label: {
    type: String,
    default: null,
  },
  /*
   * Cleass ot add to the label
   */
  labelClass: {
    type: String,
    default: null,
  },
  /*
   * id for the label control
   */
  labelId: {
    type: String,
    default: null,
  },
  labelStyle: {
    type: [String, Object],
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  /*
   * List of options to present to the user
   */
  options: {
    type: Array,
    default: ()=>[]
  },
  /*
   * The property that indicates if an option is disabled.
   * Should be a boolean value (ex: {disabled: true}), or
   * a function that evaluates to a boolean value
   */
  optionDisabled: {
    type: [String, Function],
    default: null,
  },
  /*
   * If teh topions use a group, this will determine the group's label
   */
  optionGroupLabel: {
    type: [String, Function],
    default: null,
  },
  optionGroupChildren: {
    type: [String, Function],
    default: null,
  },
  /*
   * The display label for items. This can be a
   * property name, or a function to operate on each
   * option
   */
  optionLabel: {
    type: [String, Function],
    default: null, //'label'
  },
  /*
   * The value to return from the selected option.
   * This can be a string- name of hte object's property,
   * or a function to operate on each option to yeild
   * the returned value
   */
  optionValue: {
    type: [String, Function],
    default: null, //'value',
  },
  /*
   *  Classes to add on the Overlay
   */
  overlayClass: {
    type: [String, Object],
    default: null,
  },
  /*
   *  Styling to add to the Overlay
   */
  overlayStyle : {
    type: [String, Object],
    default: null,
  },
  panelClass: {
    type: [String, Object],
    default: null,
  },
  panelStyle: {
    type: [String, Object],
    default: null,
  },
  /*
   *  Message to show when nothing has been selected.
   */
  placeholder: {
    type: String,
    default: null,
  },
  resetFilterOnHide: {
    type: Boolean,
    default: false,
  },
  resetFilterOnClear: {
    type: Boolean,
    default: false,
  },
  scrollHeight: {
    type: String,
    default: '14rem'
  },
  selectionDisplay: {
    type: String,
    default: 'topAfterReopen',
    validate: (x) => ['fixed', 'top', 'topAfterReopen'].includes(x)
  },
  /*
   * when set to true as the user arrows up or down the
   * value changes. Otherwise the user will have to use the
   * enter key or blur to make the selection.
   */
  selectOnFocus: {
    type: Boolean,
    default: false,
  },
  tabindex: {
    type: [Number, String],
    default: 0
  },
  virtualScrollerOptions: {
    type: Object,
    default: null,
  },
};
